import React, { useState } from 'react';
import { openWhatsApp } from '../utils/whatsapp';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
  const [selectedSizeIndex, setSelectedSizeIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Get the selected size object
  const selectedSize = product.sizes[selectedSizeIndex];

  const handleBuyNow = () => {
    openWhatsApp(
      product.name, 
      selectedSize.size, 
      product.category,
      selectedSize.price
    );
  };

  return (
    <div className="product-card">
      <div className="product-image-wrapper">
        {!imageLoaded && (
          <div className="image-skeleton">
            <div className="spinner"></div>
          </div>
        )}
        <img
          src={product.image}
          alt={product.name}
          className={`product-image ${imageLoaded ? 'loaded' : ''}`}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
        />
        {product.featured && (
          <span className="product-badge">Popular</span>
        )}
        <div className="product-overlay">
          {/* <button onClick={handleBuyNow} className="quick-buy-btn">
            Quick Order
          </button> */}
        </div>
      </div>

      <div className="product-details">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.description}</p>

        <div className="product-actions">
          <div className="size-selector">
            <label htmlFor={`size-${product.id}`}>Size & Price:</label>
            <select
              id={`size-${product.id}`}
              value={selectedSizeIndex}
              onChange={(e) => setSelectedSizeIndex(Number(e.target.value))}
              className="size-dropdown"
            >
              {product.sizes.map((sizeObj, index) => (
                <option key={index} value={index}>
                  {sizeObj.size} - ₹{sizeObj.price}
                </option>
              ))}
            </select>
          </div>

          <button onClick={handleBuyNow} className="btn btn-primary buy-btn">
            <span className="price-display">₹{selectedSize.price} </span>
            <span className="buy-text">Buy Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;